import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useSelector } from "react-redux";
import { NEWS_CRUMB } from "../../constants/BreadcrumConstants";
import Footer from "../footer/Footer";
import Header from "../header/Header";
import MenuHeader from "../header/MenuHeader";
import { makeGetRequest } from "../../rest/RestService";
import { useParams } from "react-router-dom";
import { NEWS_URL } from "../../constants/APIEndpointConstants";
import { sanitizeHTML } from "../../helper/SanitizeHTML";
import { Loader } from "../general/Loader";
import PageNotFound from "../not-found/PageNotFound";
import { ABOUT } from "../../constants/PageTitleConstants";

const NewsDetail = () => {
  const { hfData, error: hfError } = useSelector((state) => state.hfReducer);
  const { news } = useParams();
  const [page, setPage] = useState({});
  const [loader, setLoader] = useState(true);
  const [titleRef, setTitleRef] = useState();

  useEffect(() => {
    if (hfData?.header) {
      makeGetRequest(`${NEWS_URL}/${news}`)
        .then((res) => {
          setPage(res.data.news[0]);
        })
        .catch((err) => setPage({ error: err.message }))
        .finally(() => {
          setLoader(false);
        });
    }
  }, [news, hfData?.header]);

  return (
    <>
      {loader ? (
        <Loader />
      ) : hfData?.header && page ? (
        <>
          <Header data={hfData} />
          <div className="container-fluid blog_bg">
            <Helmet>
              <title>{titleRef?.innerText?.concat(ABOUT)}</title>
            </Helmet>
            <div className="row">
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <MenuHeader
                  crumbs={[
                    NEWS_CRUMB,
                    {
                      title: (
                        <span
                          dangerouslySetInnerHTML={sanitizeHTML(page?.title)}
                        ></span>
                      ),
                    },
                  ]}
                  textColor="subject_intro_text"
                  breadCrumbColor="subject_padding"
                  labelColor="lable_hlight"
                />
                <div className="container-fluid refine_section">
                  <div className="row">
                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                      <div className="container subject_padding">
                        <div className="row">
                          <div
                            className="col-xs-12 col-sm-12 col-md-12 col-lg-12 subject_intro_text"
                            style={{ paddingTop: "0px" }}
                          >
                            <div className="row">
                              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                <div className="circle">
                                  <span className="ndate">{page?.date}</span>
                                  <span className="nmonth">{page?.month}</span>
                                </div>
                                <div className="blog_title_single pull-left">
                                  <h2
                                    className="blog_title_new"
                                    dangerouslySetInnerHTML={sanitizeHTML(
                                      page?.title
                                    )}
                                    ref={(e) => setTitleRef(e)}
                                  ></h2>
                                  <div className="blog_tagline_info">
                                    Posted By polity_admin_user
                                  </div>
                                </div>
                              </div>
                              <div
                                style={{
                                  paddingTop: "20px",
                                  paddingLeft: "0px",
                                  border: "solid red 0px",
                                }}
                                className="blog_content"
                              >
                                <p
                                  dangerouslySetInnerHTML={sanitizeHTML(
                                    page?.content
                                  )}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer data={hfData} />
        </>
      ) : (
        <><PageNotFound pageError={page?.error || hfError} /></>
      )}
    </>
  );
};

export default NewsDetail;
